// Composite/action sections with no field or override representation at all -
// their real "content" is a status or action, not something a field-emptiness
// check can judge, so they're always shown regardless. (launch/offboard were
// tried here briefly too, driven by fields shared with other, currently-
// configured sections like driverValidation/vehicleValidation - that made
// them show up "with content" for vehicles that never actually used launch/
// offboard at all, just because those other sections happened to be filled
// in. Not fixable without tracking historical config, so reverted - nobody
// was relying on seeing these anyway.)
const ALWAYS_SHOW_KEYS = ['launch', 'offboard', 'checkout'];

// A section counts as having content in the main grid if it's been
// overridden (always shown, override note and all), or if any of its
// non-document fields actually has a value on this gas object. Document
// fields never count here - a section made up entirely of picture fields
// belongs in the Pictures listing instead, not an empty box in the grid.
// This naturally handles the picture-only sections (their fields are all
// document-type, so nonDocumentFields ends up empty -> hidden) without
// needing a separate check - including damagePictures, whose photos aren't
// FK fields at all (so they never even appear in section_field_meta) but
// whose damage_description IS a real field and should still show normally.
// Sections whose only declared field is the override itself (registration,
// equipment, fhv, repair, svid_decal, calamp - their real completion check
// lives on the vehicle, not any Gas field) end up with an empty fields list
// after the override is filtered out - that's genuinely empty, not a signal
// to always show, so they follow the same rule as everything else.
const hasSectionContent = (section, gas) => {
  if (!!section.override && !!gas?.[section.override]) return true;

  if (ALWAYS_SHOW_KEYS.includes(section.key)) return true;

  if (section.key === 'charges') return !!gas?.gas_charges?.length;

  const fields = gas?.section_field_meta?.[section.key]?.fields || [];
  const nonDocumentFields = fields.filter(({type}) => type !== 'document');
  if (!nonDocumentFields.length) return false;

  return nonDocumentFields.some(({field}) => {
    const value = gas?.[field];
    return value !== null && value !== undefined && value !== '' && value !== false;
  });
};

export default hasSectionContent;
